import React from 'react';

import signalstrength0 from './signal-strength-0.png';
import signalstrength1 from './signal-strength-1.png';
import signalstrength2 from './signal-strength-2.png';
import signalstrength3 from './signal-strength-3.png';
import signalstrength4 from './signal-strength-4.png';
import signalstrength5 from './signal-strength-5.png';

export function SignalStrengthIndicator(props) {

  const getImage = (value) => {
    value = Math.ceil(value);
    if (value <= 0) return signalstrength0;
    else if (value === 1) return signalstrength1;
    else if (value === 2) return signalstrength2;
    else if (value === 3) return signalstrength3;
    else if (value === 4) return signalstrength4;
    else return signalstrength5;
  }

  return (
    <img
      src={getImage(props.strength)}
      height="16"
      className="d-inline-block"
      alt={props.strength}
    />
  )
}
